module.exports = __webpack_public_path__ + "img/Domini_Code.f88e2808.jpg";